import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import _ from 'lodash';
import moment from 'moment';

import CopyHistoricalDialog from './copy_historical_dialog';
import SectionPaper from '../../../../../common/section_paper';
import { Button } from '../../../../../common/button';
import { MISC_DATE_ISO_DATE_ONLY_FORMAT } from '../../../../../../core/constants';
import { getProductsFromProductAvailabilityForDocumentNotificationData } from '../../../../../../core/utils/notification_utils';
import { getProductsFromProductAvailabilityForDocumentAction, getProductsFromProductAvailabilityForDocumentState } from '../../../../../../features/product/get_products_from_product_availability_for_document';
import useNotification from '../../../../../../core/hooks/use_notification';
import { ApiRequestStatusEnum } from '../../../../../../core/enums/common/api';

const AdditionalOptions = ({ onChangeSetDate, displayCopyHistoricalDialog, form, onCopyHistoricalOrder, formik }) => {
    const dispatch = useDispatch();
    const { showErrorMessage } = useNotification();
    const [allDates, setAllDates] = useState(false);
    const onChangeSetDateDebounced = _.debounce((value) => onChangeSetDate(value, allDates), 600);

    const getProductsFromProductAvailabilityForDocument = useSelector(getProductsFromProductAvailabilityForDocumentState);

    const onImportReservations = () => {
        const foodPartnerId = form?.foodPartnerId || formik?.values?.foodPartnerId;
        const date = form?.orderDate ? form?.orderDate?.format(MISC_DATE_ISO_DATE_ONLY_FORMAT) : formik?.values?.orderDate?.format(MISC_DATE_ISO_DATE_ONLY_FORMAT);

        dispatch(getProductsFromProductAvailabilityForDocumentAction({ foodPartnerId: foodPartnerId, date: date }))
            .then(response => {
                showErrorMessage(getProductsFromProductAvailabilityForDocumentNotificationData(response));

                if (response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED) {
                    const payloadProducts = response?.payload || [];
                    const currentProductsList = [...(formik?.values?.productsList[0] || [])];

                    if (payloadProducts.length === 0) {
                        return;
                    }

                    const mapPayloadToProduct = (product, index) => {
                        const orderDateMoment = form?.orderDate || formik?.values?.orderDate;

                        return {
                            position: index,
                            name: product?.name,
                            productId: product?.id,
                            productBatchId: '',
                            quantity: product?.generalAvailabilityQuantityLimit || 0,
                            expirationDate: product?.defaultDaysToExpiration && orderDateMoment
                                ? moment(orderDateMoment).add(Math.max(product?.defaultDaysToExpiration - 1, 0), 'days')
                                : '',
                            price: product?.purchaseNetPrice ? Number(product.purchaseNetPrice).toFixed(2) : '',
                            type: product?.type
                        };
                    };

                    if (currentProductsList?.length === 0) {
                        const newProductsList = payloadProducts.map((product, index) => mapPayloadToProduct(product, index));
                        formik.setFieldValue(`productsList.${ 0 }`, newProductsList);
                        return;
                    }

                    const updatedProductsList = [...currentProductsList];

                    payloadProducts.forEach((newProduct) => {
                        const existingProductIndex = updatedProductsList.findIndex((oldProduct) => oldProduct.productId === newProduct.id);

                        if (existingProductIndex !== -1) {
                            const oldQuantity = Number(updatedProductsList[existingProductIndex].quantity) || 0;
                            const newQuantity = Number(newProduct.generalAvailabilityQuantityLimit) || 0;

                            if (newQuantity > oldQuantity) {
                                updatedProductsList[existingProductIndex] = {
                                    ...updatedProductsList[existingProductIndex],
                                    quantity: newProduct.generalAvailabilityQuantityLimit,
                                };
                            }
                        } else {
                            const nextIndex = updatedProductsList.length;
                            updatedProductsList.push(mapPayloadToProduct(newProduct, nextIndex));
                        }
                    });

                    formik.setFieldValue(`productsList.${ 0 }`, updatedProductsList);
                }
            });
    };

    return (
        <SectionPaper title="Opcje dodatkowe">
            <Box sx={ {
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', md: 'center' },
                gap: 3
            } }>

                <Stack direction="row" spacing={ 3 } alignItems="center" flexWrap="wrap" useFlexGap>
                    <DatePicker
                        displayWeekNumber
                        label="Ustaw datę przydatności"
                        onChange={ newDate => newDate?.isValid() && onChangeSetDateDebounced(newDate) }
                        slotProps={ {
                            textField: {
                                size: 'small',
                                sx: { width: 250 }
                            }
                        } }
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                color="primary"
                                checked={ allDates }
                                onChange={ (e) => setAllDates(e.target.checked) }
                            />
                        }
                        label={ <Typography variant="body2">Uzupełnij dla wszystkich lokalizacji</Typography> }
                        sx={ { m: 0 } }
                    />
                </Stack>

                <Box sx={ { display: 'flex', gap: 3 } }>
                    { displayCopyHistoricalDialog &&
                        <CopyHistoricalDialog
                            form={ form }
                            onCopyHistoricalOrder={ onCopyHistoricalOrder }
                        />
                    }
                    <Button onClick={ onImportReservations } isLoading={ getProductsFromProductAvailabilityForDocument?.loading }>
                        Import rezerwacji
                    </Button>
                </Box>

            </Box>
        </SectionPaper>
    );
};

export default AdditionalOptions;